import React from 'react';

/**
 * LLM / stored copy often escapes markdown (`\*\*word\*\*`, `&#42;`).
 * Unescape first so **bold** / *italic* can actually render.
 */
export function unescapeMarkdownAsterisks(text) {
  if (text == null) return '';
  return String(text)
    .replace(/&#42;|&ast;/g, '*')
    .replace(/\\\*/g, '*');
}

/**
 * Renders vocabulary nuance strings: **bold** then *italic* (single-asterisk emphasis).
 * Bold segments are parsed first so inner asterisks in **...** are not treated as italic.
 */
export function renderNuanceInlineMarkdown(text) {
  if (text == null || text === '') return null;
  const boldChunks = unescapeMarkdownAsterisks(text).split(/\*\*(.+?)\*\*/g);
  const out = [];
  let key = 0;
  boldChunks.forEach((chunk, i) => {
    if (i % 2 === 1) {
      out.push(React.createElement('strong', { key: `b${key++}` }, chunk));
      return;
    }
    if (!chunk) return;
    const italicChunks = chunk.split(/\*([^*]+?)\*/g);
    italicChunks.forEach((c, j) => {
      if (j % 2 === 1) {
        out.push(React.createElement('em', { key: `i${key++}` }, c));
      } else if (c) {
        out.push(c);
      }
    });
  });
  return out.length ? out : null;
}
